$(document).ready(function () {
    let __rtl = false
    if ($("body").css('direction') == 'rtl'){
        __rtl = true
        if ($(window).width() > 992){
            $('.reseve-room-information-modal-hide').on('click', function () {
                $('.reseve-room-information-modal').animate({
                    left: '-60%',right: 'unset'
                }, 500)
                $('.modal-overlay').hide()
            })

            $('.modal-overlay').on('click', function () {
                $('.reseve-room-information-modal').animate({
                    left: '-60%',right: 'unset'
                }, 500)
                $(this).hide()
            })
        }else{
            $('.reseve-room-information-modal-hide').on('click', function () {
                $('.reseve-room-information-modal').animate({
                    left: '-100%'
                }, 500)
            })
        }

        $(window).resize(function () {
            if ($(window).width() > 992){
                $('.reseve-room-information-modal').animate({left: '-60%',right: 'unset'}, 500)
                $('.modal-overlay').hide()
            }else{
                $('.reseve-room-information-modal').animate({left: '-100%',right: 'unset'}, 500)
                $('.modal-overlay').hide()
            }
        })
    }else{
        if ($(window).width() > 992){
            $('.reseve-room-information-modal-hide').on('click', function () {
                $('.reseve-room-information-modal').animate({
                    right: '-60%'
                }, 500)
                $('.modal-overlay').hide()
            })

            $('.modal-overlay').on('click', function () {
                $('.reseve-room-information-modal').animate({
                    right: '-60%'
                }, 500)
                $(this).hide()
            })   
        }else{
            $('.reseve-room-information-modal-hide').on('click', function () {
                $('.reseve-room-information-modal').animate({
                    right: '-100%'
                }, 500)
            })
        }

        $(window).resize(function () {
            if ($(window).width() > 992){
                $('.reseve-room-information-modal').animate({right: '-60%'}, 500)
                $('.modal-overlay').hide()  
            }else{
                $('.reseve-room-information-modal').animate({right: '-100%'}, 500)
                $('.modal-overlay').hide()
            }  
        })
    }

    // show and hide reserve room information modal
    $('.reseve-room-information-modal-show').on('click', function () {
        let id = $(this).data('id')
        getHotelInfo(id)
        if ($("body").css('direction') == 'rtl'){
            if ($(window).width() > 992){
                $('.reseve-room-information-modal').animate({left: 0,right: 'unset'}, 500)
                $('.modal-overlay').show()
            }else{
                $('.reseve-room-information-modal').animate({left: 0}, 500)
            }
        }else{
            if ($(window).width() > 992){
                $('.reseve-room-information-modal').animate({right: 0}, 500)
                $('.modal-overlay').show()
            }else{
                $('.reseve-room-information-modal').animate({right: 0}, 500)
            }
        }
    })

    // images Show Carousel
    $('.images-show-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        rtl: __rtl,
        navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        dots: false,
        dotsContainer: '.interior',
        rewind: true,
        center: true,
        items: 1
    }).on("changed.owl.carousel", function (e) {
        $(".images-thumbs-carousel").trigger("to.owl.carousel", [e.item.index - 2, 200, !0]);
    });

    // images Thumbs Carousel
    $('.images-thumbs-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        rtl: __rtl,
        center: true,
        rewind: true,
        autoWidth: true,
        items: 1
    }).on("click", ".owl-item .item", function () {
        var x = $(this).parent().index();
        $(".images-show-carousel").trigger("to.owl.carousel", [x - 2, 200, !0])
        $(this).parent().addClass('center').siblings().removeClass('center')
    });

    $('.room-hotel-images-carousel').owlCarousel({
        items:1,
        loop: true,
        nav: true,
        dots: false,
        margin:10,
        mouseDrag:true,
        rtl: __rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    });

    $('.popular-hotels-carousel').owlCarousel({
        margin: 20,
        loop: false,
        nav: true,
        dots: false,
        stagePadding:10,
        mouseDrag:true,
        rtl: __rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        responsive: {
            0: {
                items: 1,
                margin: 10,
                autoWidth:true,
            },
            576: {
                items: 1,
                autoWidth:false,
            },
            768: {
                items: 2,
            },
            1200: {
                items: 3
            }
        }
    })

    $('.popular-hotels-images-carousel').owlCarousel({
        items:1,
        loop: true,
        nav: true,
        dots: false,
        margin:10,
        mouseDrag:true,
        touchDrag:true,
        lazyLoad : true,
        rtl: __rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
    }).on('mousedown', function(event) {
        event.stopPropagation()
    })

    $('.popular-places-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: false,
        rtl: __rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        responsive: {
            0: {
                items: 2,
                margin: 8,
                autoWidth:true,
            },

            576: {
                items: 3,
                margin: 10,
            },

            768: {
                items: 4,
            },

            1200: {
                items: 5
            },
        }
    })

    //to hide read more if description is short
    var lengthContent = $('.content .description .desc').text().replace(/\s/g, '').length
    if (lengthContent < 250) {
        $('.content .description .read-more').hide()
        $('.content .description .background-opacity').hide()
        $('.content .description .desc').css('max-height', 'unset')
    }

    $('.content .description .read-more').click(function() {
        $(this).hide().parent().addClass("open")
    })

    $('.selectpicker').selectpicker()

    // this is for custom room form 
    $('input[name="daterange"]').daterangepicker({
        opens: 'right'
    })

    // show and hide reserve room modal
    $('.hotel-single-page .mobile-reseve-room-show').on('click', function () {
        $('.reseve-room-modal').animate({
            top: 80,bottom:'100vh'
        }, 500)
    })

    $('.hotel-single-page .mobile-reseve-room-hide').on('click', function () {
        $('.reseve-room-modal').animate({
            top: '-100vh',bottom:'unset'
        }, 500)
    })

    guestSelect ();

    // this is for get information of hotel to insert in the modal content
    async function getHotelInfo (id) {
        await $.ajax({
            url: `/api/v1/hotel/` + id + `?lang=${getLanguage()}`,
            method: 'get',
            success: function (response) {
                $('.reseve-room-information-modal .content-modal-information').html(response)
    
                $('.images-show-carousel').owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: true,
                    rtl: __rtl,
                    navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
                    navClass: ['owl-prev', 'owl-next'],
                    dots: false,
                    dotsContainer: '.interior',
                    rewind: true,
                    center: true,
                    items: 1,

                }).on('changed.owl.carousel', function (e) {
                    $('.images-thumbs-carousel').trigger('to.owl.carousel', [e.item.index - 2, 200, !0])
                })

                $('.images-thumbs-carousel').owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: false,
                    dots: false,
                    rtl: __rtl,
                    center: true,
                    rewind: true,
                    autoWidth: true,
                    items: 1,
                }).on('click', '.owl-item .item', function () {
                    var x = $(this).parent().index()
                    $('.images-show-carousel').trigger('to.owl.carousel', [x - 2, 200, !0])
                    $(this).parent().addClass('center').siblings().removeClass('center')
                })
                
                $('.room-hotel-images-carousel').owlCarousel({
                    items:1,
                    loop: true,
                    nav: true,
                    dots: false,
                    margin:10,
                    mouseDrag:true,
                    rtl: __rtl,
                    navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>']
                });

                $('.selectpicker').selectpicker()

                // this is for custom room form 
                $('input[name="daterange"]').daterangepicker({
                    opens: 'right'
                })

                guestSelect();
            }
        }); 
        
        await $.ajax({
            url: `/api/v1/country-code`,
            method: "GET",
            dataType: "json",
            success: function (data) {
                $(".phoneInput").intlTelInput({
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.2/js/utils.js",
                    nationalMode: true,
                    separateDialCode: true,
                    initialCountry: data,
                    preferredCountries: ['SA', 'QA', 'TR', 'IQ', 'KW', 'BH', 'AE', 'YE', 'JO', 'DZ', 'TN', 'LY', 'EG', 'SD', 'OM', 'SY']
                });
            }
        })
    }

    function getLanguage () {
        let language = '';
        switch (document.documentElement.lang) {
            case 'en':
                language = 'en';
            break;
            case 'ar':
                language = 'ar';
            break;
            case 'fr':
                language = 'fr';
            break;
        }
        return language
    }

    // this is for custom guest select
    function guestSelect () {
        $('.guest-select .input-contain .form-control').focus(function() {
            $('.guest-menu').toggle()
            $(this).blur()
            let arrayValue = $('input[name=guest]').val().match(/\d/g)
            if(arrayValue){
                $('input[name=adult-number]').val(arrayValue[0])
                $('.guest-menu .list .item .adult .result1').html(arrayValue[0]);
                $('input[name=child-number]').val(arrayValue[1])
                $('.guest-menu .list .item .child .result2').html(arrayValue[1]);
            }else{
                $('input[name=adult-number]').val(0)
                $('.guest-menu .list .item .adult .result1').html(0);
                $('input[name=child-number]').val(0)
                $('.guest-menu .list .item .child .result2').html(0);
            }
        })
        
        $(document).on('click', function (event) {
            var $trigger = $('.guest-select')
            if ($trigger !== event.target && !$trigger.has(event.target).length) {
                $('.guest-menu').hide()
            }
        })
        
        $('.guest-menu .list .item .adult .less,.guest-menu .list .item .adult .more').click("on", function(e) {
            e.preventDefault();
            let adultValue = parseInt($('input[name=adult-number]').val());
            let adultClassName = $(this).attr("class");
            if (adultClassName === "less") {
                if (adultValue == 0)
                    return;
                else {
                    $('input[name=adult-number]').val(adultValue - 1);
                    $('.guest-menu .list .item .adult .result1').html(adultValue - 1);
                }
        
            } else {
                if (adultValue == 10)
                    return;
                else {
                    $('input[name=adult-number]').val(adultValue + 1);
                    $('.guest-menu .list .item .adult .result1').html(adultValue + 1);
                }
            }
        })
        
        $('.guest-menu .list .item .child .less,.guest-menu .list .item .child .more').click("on", function(e) {
            e.preventDefault();
            let childValue = parseInt($('input[name=child-number]').val());
            let childClassName = $(this).attr("class");
            if (childClassName === "less") {
                if (childValue == 0)
                    return;
                else {
                    $('input[name=child-number]').val(childValue - 1);
                    $('.guest-menu .list .item .child .result2').html(childValue - 1);
                }
        
            } else {
                if (childValue == 10)
                    return;
                else {
                    $('input[name=child-number]').val(childValue + 1);
                    $('.guest-menu .list .item .child .result2').html(childValue + 1);
                }
            }
        })
        
        $('.guest-select .input-contain .guest-menu .list .actions .cancel').click("on", function(e) {
            e.preventDefault();
            $('.guest-menu').hide()
        })
        
        $('.guest-select .input-contain .guest-menu .list .actions .save').click("on", function(e) {
            e.preventDefault();
            if($('input[name=adult-number]').val() == 0 && $('input[name=child-number]').val() == 0){
                $('input[name=guest]').val('')
            }else{
                if(__rtl) {
                    $('input[name=guest]').val(parseInt($('input[name=adult-number]').val()) + ' بالغ | ' + parseInt($('input[name=child-number]').val()) + ' طفل');
                }else{
                    $('input[name=guest]').val(parseInt($('input[name=adult-number]').val()) + ' adult | ' + parseInt($('input[name=child-number]').val()) + ' child');
                }
            }
            $('.guest-menu').hide()
        })
    }
})